import { createAction } from "typesafe-actions";
import { ErrorHandlingActionTypes } from "./error-handling-types";
import { ErrorSeverity } from "~/types/errorTypes";

export const setErrorSeverityType = createAction(
    ErrorHandlingActionTypes.SET_ERROR_SEVERITY_TYPE,
    resolve => (errorSeverity: ErrorSeverity) => resolve({ errorSeverity })
);
export const showErrorModal = createAction(
    ErrorHandlingActionTypes.SHOW_ERROR_MODAL,
    resolve => (errorMessage: string) => resolve({ errorMessage })
);
export const showErrorInline = createAction(
    ErrorHandlingActionTypes.SHOW_ERROR_INLINE,
    resolve => (errorMessage: string) => resolve({ errorMessage })
);
export const hideErrorModal = createAction(ErrorHandlingActionTypes.HIDE_ERROR_MODAL);
export const resetErrors = createAction(ErrorHandlingActionTypes.RESET_ERRORS);
